export const TEST_ID = 'weatherStrip';

export const OBSERVATION_FRESH_THRESHOLD_MS = 60 * 60 * 1000;
